// extracted by mini-css-extract-plugin
module.exports = {"explanationContainer":"answers_explanationContainer__2FdoR","explanationTitle":"answers_explanationTitle__SEe7k","explanationDescription":"answers_explanationDescription__38_Yf"};